<div [ngStyle]="css" [innerHTML]="safeHtml"></div>
<div *ngIf="question.isHeadline" id="afterTitle"></div>
